export default __webpack_public_path__ + "img/table_benefits-70959ac53003139f868d661c3235e107.png";